<template>
  <div style="min-height: 92vh">
    <div v-show="!showCreator">
      <ModuleHeader>Orden de compra por insumo</ModuleHeader>
      <uv-data-table
        :config="config"
        :data="Documentos"
        :pageRows="15"
        @buttonClick="dtButtonClick"
      ></uv-data-table>
    </div>

    <modal
      v-model="showModal"
      :showFooter="false"
      :fullscreen="true"
      title="Orden de compra"
    >
      <OrdenesCompraForm
        :edit="editMode"
        @toggle="toggleModal"
        @successData="successData"
        :key="formIndex"
        :dataEdit="editData"
      />
    </modal>
  </div>
</template>

<style></style>

<script>
import moment from "moment";
import modal from "../../MainComponents/modal.vue";
import uvDataTable from "../../MainComponents/DataTable.vue";
import OrdenesCompraForm from "./OrdenCompraForm.vue";
export default {
  name: "OrdenesCompraCRUD",
  components: {
    modal,
    uvDataTable,
    OrdenesCompraForm,
  },
  props: [],
  data() {
    return {
      origenes: [],
      self: this,
      showModal: false,
      formKey: 0,
      Documentos: [],
      formIndex: 0,
      editMode: false,
      showCreator: false,
      editData: [],

      config: {
        orderByCol: { Field: "", Type: "Asc" },
        selectableRow: true,
        allowExport: true,
        rawText: "Orden de compra",
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Nueva orden de compra",
            icon: "lni lni-clipboard",
            buttonId: "addDocumentRecepcion",
          },
          {
            text: "Editar orden de compra",
            icon: "lni lni-pencil-alt",
            buttonId: "editDocumentRecepcion",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteDocumentRecepcion",
            require: true,
          },
          {
            text: "Generar desde existencia ideal",
            icon: "lni lni-checkbox",
            buttonId: "existenciasIdeales",
          },
        ],
        fields: [
          {
            text: "Documento orden de compras",
            value: "Nombre",
          },
          {
            text: "Fecha Creación",
            value: "Fecha",
          },
          {
            text: "Almacen",
            value: "origenNombre",
            canBeFiltered: true,
          },
          {
            canBeFiltered: true,
            text: "Estatus",
            value: "Status",
            format: (row) => {
              if (row["sts"] == "A") {
                return '<b style="color:green;">Aprobado</b>';
              } else {
                return '<b style="color:orange;">Pendiente</b>';
              }
            },
          },
        ],
      },
    };
  },
  methods: {
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "addDocumentRecepcion") {
        this.formIndex++;
        this.editMode = false;
        this.showModal = true;
      }
      if (buttonId == "editDocumentRecepcion") {
        this.formIndex++;
        this.editMode = true;
        this.editData = this.$pgsHelper.getById(
          this.Documentos,
          "id",
          idSelected[0]
        );
        this.showModal = true;
      }

      if (buttonId == "deleteDocumentRecepcion") {
        this.deleteDoc(idSelected[0]);
      }
      
      if (buttonId == "existenciasIdeales") {
        this.$router.push({
          path: "/productos-inventarios/orden-compra-ideales",
        });
      }
    },
    async createDocument() {
      this.$swal({
        title: "¿Deseas crear un nuevo documento de recepción de mercancias?",
        text: "Al crear el documento podras agregar los productos necesarios para ingresar a inventario",
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Crear Documento",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          let data = {};
          return await this.$store.getters.getFirebaseApp.fba
            .call("ProShop-Productos-deleteCategoria", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Documento Creado",
              "El documento se creo correctamente",
              "success"
            );
            this.$router.push({
              path:
                "/productos-inventarios/documentoRecepcion/" +
                result.value.data.data.id,
            });
          } else {
            this.$swal("Error deleting data", result.value.data.error, "error");
          }
        }
      });
    },
    getDocuById(code) {
      let itemIndex = this.$_.findIndex(this.Documentos, { id: code });
      if (itemIndex >= 0) {
        return this.Documentos[itemIndex];
      }

      return false;
    },
    async successData() {
      await this.getDocuments();
      this.showModal = false;
    },
    toggleModal(open) {
      this.showModal = open;
    },
    async deleteDoc(id) {
      let docu = this.getDocuById(id);
      if (docu.Aplicado) {
        this.$swal(
          "No puedes eliminar un documento aplicado a inventario",
          "",
          "error"
        );
        return false;
      }
      let datos = {
        Id: id,
        TipoMovimiento: "Entrada",
      };

      this.$swal({
        title: "¿Deseas el documento de entrada de mercancias?",
        text: "Al eliminarlo se perderan todos los datos",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        allowOutsideClick: false,
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("ProShop-Inventario-eliminarPreInventario", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Documento se elimino correctamente",
              "El documento se elimino correctamente",
              "success"
            );
            this.getDocuments();
          } else {
            this.$swal("Error deleting data", result.value.data.error, "error");
          }
        }
      });
    },
    async getDocuments() {
      this.Documentos = [];
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      var data = await firestore.queryBuilder("AMC_OrdenesCompra", [
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ]);

      //this.$pgsHelper.log(data.docs.map(doc=>{return {id:doc.ref.id,...doc.data()}}));
      let document = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });

      document.forEach((data) => {
        /* let dateFormat = new firestore.Timestamp(
            data.FechaCreacion.seconds,
            data.FechaCreacion.nanoseconds
          );*/
        let fecha = new moment(data.mmt, "YYYY-MM-DD_HH:mm:ss");
        let origenData = this.getOrigenById(data.amc);
        this.Documentos.push({
          id: data.id,
          origenId: origenData.id,
          origenNombre: origenData.Nombre,
          Nombre: "Orden de compra - " + data.id,
          Fecha: fecha.format("YYYY-MM-DD HH:mm"),
          //Departamento: data.Departamentos[0],
          Aplicado: data.sts,
          Status: data.sts == "F" ? "Completado" : "Pendiente",
          ...data,
        });
      });

      this.Documentos = this.$_.orderBy(this.Documentos, "Fecha", "desc");
    },
    async getOrigenes() {
      var data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "PDV/Inventario/Origenes"
      );

      if (!data.exists()) {
        return false;
      }
      let arrayOrg = Object.entries(data.val());
      let origenes = [];
      arrayOrg.forEach((element) => {
        if (!this.$route.params.idDocumento) {
          this.Origen = element[0];
        }
        //this.Origen =  element[0];
        origenes.push({
          id: element[0],
          Nombre: element[1]["Nombre"],
          Departamentos: element[1]["Departamentos"],
        });
      });

      this.origenes = origenes;
    },
    getOrigenById(code) {
      let itemIndex = this.$_.findIndex(this.origenes, { id: code });
      if (itemIndex >= 0) {
        return this.origenes[itemIndex];
      }

      return false;
    },
  },
  computed: {},
  watch: {},
  mounted() {},
  async created() {
    await this.getOrigenes();
    await this.getDocuments();
  },
};
</script>
